import { render, staticRenderFns } from "./MainNoticeSetting.vue?vue&type=template&id=bc4bb558"
import script from "./MainNoticeSetting.vue?vue&type=script&lang=js"
export * from "./MainNoticeSetting.vue?vue&type=script&lang=js"
import style0 from "./MainNoticeSetting.vue?vue&type=style&index=0&id=bc4bb558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
